@if (status() === 'loading') {
  <div class="inbound-container">
    <p>Authenticating, please wait...</p>
  </div>
} @else if (status() === 'error') {
  <div class="inbound-container inbound-error">
    <p>{{ errorMessage() }}</p>
  </div>
}
